export function getToken(): string {
  return localStorage.getItem('access_token') || localStorage.getItem('token') || '';
}

export function authHeaders(): Record<string, string> {
  return {
    Authorization: 'Bearer ' + getToken(),
    'Content-Type': 'application/json',
  };
}